module.exports = __webpack_public_path__ + "lp/img/language-blue.f6ac6a25.svg";